import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { p, pt, pb, px, py, mt, mb, mx } from 'styled-components-spacing';
import { map } from 'styled-components-breakpoint';
import { colors, Text, Heading } from 'themes/components';

import HighlightText from 'utils/HighlightText';
import GradientButton from 'components/GradientButton';

const Container = styled.div`
  ${pt({ mobile: 6 })};
  ${pb({ mobile: 2 })};
  ${px(2)};
  margin: 0 auto;
  ${mt(4)};
  display: grid;
  justify-content: center;
  ${map(
    {
      mobile: '24px',
      tablet: '32px'
    },
    (gap) => `gap: ${gap};`
  )}
  ${map(
    {
      mobile: '1fr',
      tablet: 'repeat(2, minmax(350px, 475px))'
    },
    (cols) => `grid-template-columns: ${cols};`
  )}
  align-items: start;
`;

const ForArtists = styled.div`
  border-radius: 24px;
  background: linear-gradient(
        to bottom right,
        hsla(204, 10%, 9%, 1),
        hsla(204, 10%, 9%, 1)
      )
      padding-box,
    linear-gradient(
        to top left,
        rgba(179, 210, 86, 0.15),
        rgba(253, 180, 251, 0.23)
      )
      border-box;
  border: 1px solid transparent;
`;

const ForArtLeads = styled.div`
  border-radius: 24px;
  background: linear-gradient(
        to bottom right,
        hsla(204, 10%, 9%, 1),
        hsla(204, 10%, 9%, 1)
      )
      padding-box,
    linear-gradient(
        to top left,
        hsla(165, 21%, 40%, 0.5),
        hsla(266, 23%, 45%, 0.5)
      )
      border-box;
  border: 1px solid transparent;
`;

const Content = styled.div`
  ${px(3)};
  ${pb(3)};
  & > h3 {
    color: ${colors.grey5};
    ${mb(0)}
  }
  & > p {
    color: ${colors.grey30};
    ${mb(2)}
  }
`;

const Personas = () => (
  <Container>
    <ForArtists>
      <StaticImage src="./images/for-artists-card_bg.png" />
      <Content>
        <Text style={{ fontWeight: '600', marginBottom: '2px' }}>
          <HighlightText stopOne={colors.pink30} stopTwo={colors.purple40}>
            Artists &rarr;
          </HighlightText>
        </Text>
        <Heading variant="h3">Focus more on art.</Heading>
        <Text>
          Get timely feedback for work in progress, on your schedule. Waste less
          time and work by not waiting for review meetings. Spend more time
          creating.
        </Text>
        <GradientButton
          url="/for-artists"
          borderColor1="rgba(179, 210, 86, 0.35)"
          borderColor2="rgba(253, 180, 251, 0.53)"
          hoverBg1={colors.pink30}
          hoverBg2={colors.purple40}
        >
          More features for artists &rarr;
        </GradientButton>
      </Content>
    </ForArtists>
    <ForArtLeads>
      <StaticImage src="./images/for-art-leads-card_bg.png" />
      <Content>
        <Text style={{ fontWeight: '600', marginBottom: '2px' }}>
          <HighlightText stopOne={colors.green30} stopTwo={colors.teal40}>
            Art leads &rarr;
          </HighlightText>
        </Text>
        <Heading variant="h3">Give better feedback.</Heading>
        <Text>
          Share regular asynchronous feedback to keep your team on track. Find
          what you need fast. Inspect content without downloading and opening
          files.
        </Text>
        <GradientButton
          url="/for-art-leads"
          borderColor1="hsla(165, 21%, 40%, 0.75)"
          borderColor2="hsla(266, 23%, 45%, 0.75)"
          hoverBg1={colors.green30}
          hoverBg2={colors.teal40}
        >
          More features for art leads &rarr;
        </GradientButton>
      </Content>
    </ForArtLeads>
  </Container>
);

export default Personas;
